import React, { ReactElement, useEffect } from 'react'
import Divider from '../../Divider'
import VotesOverview from './VotesOverview'
import { ArtData } from '@/database/art'

const VotesClaimsPanel = ({ artData, tabName }: { artData: ArtData | undefined; tabName: string }): ReactElement => {
    useEffect(() => {
        window.location.hash = `#art-${artData?.art.id + tabName}#tokenomics`
    }, [artData])

    return (
        <div className="panel">
            <Divider />
            <VotesOverview artData={artData} />
        </div>
    )
}

export default VotesClaimsPanel
